import { FC } from "react"
import { UserbotPage } from "./userbotPage"
import { ProxiesTable } from "../components"

export const ProxiesPage: FC = () => (
  <UserbotPage title="Прокси">
    <ProxiesTable />
  </UserbotPage>
)
